import { render, staticRenderFns } from "./RealityUpgradesTab.vue?vue&type=template&id=6fe970b2&scoped=true&"
import script from "./RealityUpgradesTab.vue?vue&type=script&lang=js&"
export * from "./RealityUpgradesTab.vue?vue&type=script&lang=js&"
import style0 from "./RealityUpgradesTab.vue?vue&type=style&index=0&id=6fe970b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe970b2",
  null
  
)

export default component.exports